(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["giving-carousal"]) return;
  try {
    
jQuery('.story-carousel--content').slick({
  slidesToShow: 1,
  infinite: true,
  dots: true,
  arrows: true,
  centerMode: true,
  centerPadding: '0px',
  prevArrow: $('.story-prev'),
  nextArrow: $('.story-next'),
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  function onVariantChange({target: optionValueElement}) {
    const productElement = this.querySelector('.product');
    const sectionId = this.dataset.sectionId;
    const oldProductUrl = productElement.dataset.productUrl;
    const newProductUrl = optionValueElement.dataset.productUrl;
    const newVariantId = optionValueElement.dataset.variantId;
    let params = `section_id=${sectionId}&`;
    if (newVariantId) {
      // If the option value has a variant selection, call the section rendering api for that variant
      params += `variant=${newVariantId}`;
    } else {
      // If the option value selection has no variant, call the section rendering api with the selected option value IDs instead
      const selectedOptionValues = Array.from(this.querySelectorAll('fieldset input:checked')).map((element) => element.dataset.optionValueId).join(',');
      params += `option_values=${selectedOptionValues}`;
    }
    // Call the section rendering api
    fetch(`${newProductUrl}?${params}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (newProductUrl && oldProductUrl !== newProductUrl) {
          // If the product changed, replace the old product section with the new product section
          productElement.parentNode.insertBefore(html.querySelector('.product'), productElement);
          productElement.remove();
          // Focus the input for the last clicked option value
          this.querySelector(`#${optionValueElement.id}`).focus();
          // Update anything else that depends on product, such as URL and recommended products
          return;
        }
        this.querySelector('.optionValueSelectors').innerHTML = html.querySelector('.optionValueSelectors').innerHTML;
        this.querySelector(`#${optionValueElement.id}`).focus();
        const priceEl = this.querySelector('.price');
        if (hasVariant) {
          priceEl.innerHTML = html.querySelector('.price').innerHTML;
          // Update any additional states here
        } else {
          priceEl.innerHTML = '';
          // Set additional unavailable states here
        }
      });
  }
  document.getElementById('productSection').addEventListener('change', onVariantChange);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-carousel"]) return;
  try {
    
jQuery('.story-carousel--content').slick({
  slidesToShow: 1,
  infinite: true,
  dots: true,
  arrows: true,
  centerMode: true,
  centerPadding: '0px',
  prevArrow: $('.story-prev'),
  nextArrow: $('.story-next'),
});

  } catch(e) { console.error(e); }
})();
})();
